export default __webpack_public_path__ + "static/media/map2.150b4a68.png";